const mutations = {
  historyLayanan: (state, payload) => {
    if (payload.history_data !== null) {
      state.dataHistory = state.dataHistory.concat(payload.history_data);
    }
  },

  resetPagination: (state, payload) => {
    state.pagination = payload;
  },

  setNextPagination: (state, payload) => {
    state.pagination.skip += state.pagination.limit;
    state.pagination.limit = 20;
    state.lengthRiwayat += payload.returned;
  },

  resetDataRiwayat: (state) => {
    state.dataHistory = [];
  },

  setJenisRiwayat: (state, payload) => {
    state.jenis = payload;
  },

  setOutletRiwayat: (state, payload) => {
    state.outlet = payload;
  },

  resetlengthRiwayat: (state) => {
    state.lengthRiwayat = 0;
  },

  setDetailSnapTransaksi: (state, payload) => {
    state.detailSnap = payload;
  },

  setDetailTopUp: (state, payload) => {
    state.detailTopUpToModal = payload;
  },

	setDetailRefund: (state, payload) => {
    state.detailRefund = payload;
  },

  detailTopUpModal: (state, payload) => {
    state.detailTopUpToModal = payload;
  },
  resetDetailTopUpToModal: (state) => {
    state.detailTopUpToModal = {};
  },
	setLoadingDetail: (state, payload) => {
		state.loadingDetail = payload;
	},
};

export default mutations;
